<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="value"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        @change=""
        outlined
        dense
        v-model="value"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="value"
      no-title
      scrollable
    >
      <v-spacer></v-spacer>
      <v-btn
        text
        :class="arabic ? 'arFont' : 'enFont'"
        color="primary"
        @click="menu = false"
      >
        {{ i18n.cancel }}
      </v-btn>
      <v-btn
        text
        :class="arabic ? 'arFont' : 'enFont'"
        color="primary"
        @click="save"
      >
        {{ i18n.ok }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ['date', 'field', 'label'],
  data() {
    return {
      menu: false,
      value: this.date
    }
  },
  methods: {
    save() {
      this.$refs.menu.save(this.value);
      this.$emit('saveDate', this.value, this.field)
    }
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
        arabic() {
            if (this.$store.state.language == "ar")
                return true;
        },
  }
}
</script>